import type { AxiosInstance, AxiosResponse } from 'axios';
import { govApiLog } from '@gov-nx/core/app';
import type { RegistrVozidelResponse, Vehicle } from '@gov-nx/module/page';
import { getTotalVehicleCount, getVehicleList } from '@gov-nx/module/page';

export const fetchDataPreviewsQuery =
	(axiosInstance: AxiosInstance) =>
	async <T extends { zdrojUdaju: string }, Response>(
		params: T
	): Promise<AxiosResponse<Response>> => {
		govApiLog(`/api/v1/nahledyudaju?zdrojUdaju=${params.zdrojUdaju}`);
		return await axiosInstance.get<Response>('/api/v1/nahledyudaju', {
			params,
		});
	};

export const vehicleRegistryPreviewsQuery =
	(axiosInstance: AxiosInstance) =>
	async <T extends { zdrojUdaju: string; start: number; pocet: number }>(
		params: T,
		vehicleData: Vehicle[] = []
	): Promise<Vehicle[]> => {
		const response = await axiosInstance.get<RegistrVozidelResponse>(
			'/api/v1/nahledyudaju',
			{ params }
		);
		const data = getVehicleList(response);
		const vehicleCount = getTotalVehicleCount(response);

		const newVehicleData = [...vehicleData, ...data];

		if (vehicleCount && newVehicleData.length < vehicleCount) {
			return vehicleRegistryPreviewsQuery(axiosInstance)(
				{ ...params, start: params.start + 1 },
				newVehicleData
			);
		}

		return newVehicleData;
	};
